import { requestThermostatZoneTemps } from 'console/redux/devices/items/actions';
import { OpenThermStatusFlag } from 'openTherm';
import { getLegacyControlConfig, getLegacyHeatingCircuitName, getLegacyHeatingCircuitThermometersConfig, } from './utils';
import { getConsumerControlConfig } from '../utils';
export function getLegacyHeatingCircuitsConfig(device) {
    const { id: device_id, thermostat_zones_settings, thermostat_target_temps, pza, ot_enabled, thermometers, ot_config, } = device;
    const target_temps = Object.entries(thermostat_target_temps || {});
    const zone_count = target_temps.length;
    const shared_heating_circuits = target_temps.map(([zone_id, spec]) => {
        const id = Number(~~zone_id);
        const { cascade, off } = spec;
        const zone_settings = thermostat_zones_settings?.[id];
        const name = getLegacyHeatingCircuitName(id, zone_count, zone_settings);
        const is_relay_dhw = zone_settings?.flags.includes('dhw_boiler');
        const is_boiler_adapter_dhw = id === 0;
        const is_dhw = is_boiler_adapter_dhw || is_relay_dhw;
        const show_dhw = is_relay_dhw
            ? true
            : ot_enabled && ot_config && ot_config.includes(OpenThermStatusFlag.dhw);
        const hidden_dhw = is_dhw && !show_dhw;
        const hidden_boiler = zone_settings?.flags?.includes('boiler') && (cascade || off) ? true : false;
        const is_hidden = hidden_dhw || hidden_boiler;
        if (is_hidden) {
            return null;
        }
        const thermometers_config = thermometers
            ? getLegacyHeatingCircuitThermometersConfig(id, thermometers)
            : {};
        const control_config = {
            ...getLegacyControlConfig(thermometers_config),
            has_pza: pza?.enabled ?? false,
            is_dhw,
            is_relay_dhw,
        };
        const control_mode_config = getConsumerControlConfig(control_config);
        const onTargetTemperatureChange = (target_temperature) => requestThermostatZoneTemps(device_id, {
            ...thermostat_target_temps,
            [id]: {
                temp: target_temperature,
                manual: true,
            },
        }, id);
        return {
            id,
            name,
            is_hidden,
            control_mode_config,
            thermometers_config,
            onTargetTemperatureChange,
            ...control_config,
        };
    });
    return shared_heating_circuits;
}
